import { render } from "./table-lazy-load.vue?vue&type=template&id=65222f93&ts=true"
import script from "./table-lazy-load.vue?vue&type=script&lang=ts"
export * from "./table-lazy-load.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__